<div class="modal-container">
    <div class="modal-header border-0">
      <h1 class="modal-titel text-primary-color">{{enumPopUpTitles.UNMAPPED_HEADERS}}</h1>
    </div>
    <div class="modal-body">
    <div class="col-12 px-0">
      <div class="doc-tabs">
        <div class="doc-grid h-100 d-flex flex-column position-relative customHeight">
          <app-ag-grid 
            [ngStyle]="dynamicHeight" 
            [dataModel]="agGriColumns" 
            [rowData]="data?.unmappedColumns || []"
            [paginations]="false"
            [columnSettings]="false"
            (gridReady)="onGridReady($event)">
          </app-ag-grid>
        </div>
      </div>
    </div>
    </div>
    <div class="modal-footer border-0">
      <div class="d-flex gap-3 m-0">
        <app-button
          [button_2]="true"
          [buttonClass]="'button button-info popup-button'"
          [buttonLable]="enumButtonName.CANCEL"
          (click)="activeModal.close(false)">
        </app-button>
      </div>
    </div>
</div>